import { BaseService } from "./BaseService";

export default {

    async cadastrarHora(formData) {
        const postData = JSON.stringify(formData);
        return await BaseService.fetchResponseFromAPIPost(
            `cronjob/parametrizacao`,
            postData,
            "application/json",
        );
    },

    async cadastrarCargo(formData) {
        const postData = JSON.stringify(formData);
        const response = await BaseService.fetchResponseFromAPIPost(
            `cargo`,
            postData,
            "application/json",
        );

        return response;
    },
    async updateCargo(formData) {
        const postData = JSON.stringify(formData);
        return await BaseService.fetchResponseFromAPIPost(
            `cargo/update/data`,
            postData,
            "application/json",
        );
    },

    async atribuirCargoPerfil(perfilid, formData) {
        const postData = JSON.stringify(formData);
        const response = await BaseService.fetchResponseFromAPIPost(
            `cargo/${perfilid}/funcionalidade`,
            postData,
            "application/json",
        );

        return response;
    },

    async removerCargoPerfil(perfilid, formData) {
        const postData = JSON.stringify(formData);
        const response = await BaseService.fetchResponseFromAPIDelete(
            `perfil/${perfilid}/funcionalidade`,
            postData,
        );

        return response;
    },

    async getHora() {
        return await BaseService.fetchResponseFromAPIGet(`cronjob/parametrizacao/obter`);

    },

    async getRodarAgora(){
        return await BaseService.fetchResponseFromAPIGet(`cronjob/parametrizacao/agora`);

    },

    async getPerfilUserById(idSigrh){
        const response = await BaseService.fetchResponseFromAPIGet(`perfil/${idSigrh}`);

        return response.content;

    },

    async getCargosByPerfilId(perfilid) {
        const objectResponse = {
            item: {},
        };
        const data = await BaseService.fetchResponseFromAPIGet(
            `cargos/perfil/${perfilid}`,
        );
        objectResponse.item = await data.content;

        return objectResponse.item;
    },

    async getCargos() {
        const data = await BaseService.fetchResponseFromAPIGet(`cargos`);
        const response = await data.content;
        return response;
    },

    async getMenus() {
        const data = await BaseService.fetchResponseFromAPIGet(`menu`);
        const reponse = await data.content;

        return reponse;
    },

    async getPerfis() {
        const data = await BaseService.fetchResponseFromAPIGet(`perfil`);
        const reponse = await data.content;
        console.log(reponse)
        return reponse;
    },

    async getUsersInternos(page, filters) {
        let data;

        if (filters) {
            data = await BaseService.fetchResponseFromAPIGet(
                `pessoas?page=${page}&${filters}`,
            );
        } else {
            data = await BaseService.fetchResponseFromAPIGet(
                `pessoas?page=${page}`,
            );
        }
        const reponse = await data.content;

        return reponse;
    },

    async excluirPerfil() {
        /*  const data = await BaseService.fetchResponseFromAPIDelete(
            `perfil/${perfilid}`,
          );

          return data;*/
    },

    async addPerfilUser(perfilid, userid) {
        const data = await BaseService.fetchResponseFromAPIPost(
            `perfil/${perfilid}/sigrh/${userid}`,
        );

        return data;
    },
    async showPerfil(perfilid) {
        return await BaseService.fetchResponseFromAPIGet(
            `perfil/view/${perfilid}`,
        );
    },

    async removePerfilUser(perfilid, userid) {
        const data = await BaseService.fetchResponseFromAPIDelete(
            `perfil/${perfilid}/sigrh/${userid}`,
        );

        return data;
    },

    async getCargosAcessiveis() {
        const data = await BaseService.fetchResponseFromAPIGet(
            `funcionalidades_acessiveis`,
        );
        const reponse = await data.content;

        return reponse;
    },

    async editarUserInfo(userid, postData) {
        postData.append("_method", "PUT");
        const data = await BaseService.fetchResponseFromAPIPost(
            `dados_pessoais/${userid}`,
            postData,
        );

        return data;
    },

    async validaAssinatura(postData) {
        const data = await BaseService.fetchResponseFromAPIPost(
            `assinatura`,
            postData,
        );

        return data;
    },
};